"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dialog = void 0;

var _react = _interopRequireDefault(require("react"));

var _grommet = require("grommet");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DialogContainer = (0, _styledComponents.default)(_grommet.Layer).withConfig({
  displayName: "DialogContainer",
  componentId: "sc-1nmppjh-0"
})(["width:100%;max-width:", ";overflow-y:auto;color:", ";@media ", "{max-width:100%;},"], function (p) {
  return p.maxWidth;
}, (0, _helpers.color)('black'), (0, _helpers.breakpoint)('maxMobile'));

var Dialog = function Dialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      children = _ref.children,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '712px' : _ref$maxWidth,
      _ref$disableBackdropC = _ref.disableBackdropClick,
      disableBackdropClick = _ref$disableBackdropC === void 0 ? !onClose : _ref$disableBackdropC,
      _ref$disableEscapeKey = _ref.disableEscapeKeyDown,
      disableEscapeKeyDown = _ref$disableEscapeKey === void 0 ? !onClose : _ref$disableEscapeKey,
      rest = _objectWithoutProperties(_ref, ["open", "onClose", "children", "maxWidth", "disableBackdropClick", "disableEscapeKeyDown"]);

  return open && _react.default.createElement(DialogContainer, _extends({
    maxWidth: maxWidth,
    onEsc: disableEscapeKeyDown ? undefined : onClose,
    onClickOutside: disableBackdropClick ? undefined : onClose
  }, rest), children);
};

exports.Dialog = Dialog;